import { Theme } from "shared-types";
// import { useMutation, useQueryClient } from "react-query";
// import { AxiosError } from "axios";
// import { authAxios as axios } from "shared-auth";
import { useTailwindTheme } from "shared-hooks";
// import {
//   GET_PROFILE_LAYOUT_SETTINGS,
//   useProfileLayoutSettings,
// } from "pages/Profile/hooks/useProfileLayoutSettings";

export function useProfileTheme(): [Theme, () => void] {
  // const queryClient = useQueryClient();
  const [theme, setTheme] = useTailwindTheme();

  // useProfileLayoutSettings();

  // const { mutate } = useMutation<unknown, AxiosError, { theme: Theme }>({
  //   mutationFn: (data) => {
  //     return axios.post("", data);
  //   },
  //   onSuccess: () => queryClient.invalidateQueries(GET_PROFILE_LAYOUT_SETTINGS),
  // });

  return [
    theme,
    () => {
      // mutate({ theme });
      setTheme();
    },
  ];
}
